import axios from 'axios';

const PortalMarkRecord = {
    namespaced: true,
    actions: {
        CreateMarkRecord({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalMarkRecord/CreateMarkRecord`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        CreateMarkRecordMidTerm({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };
                axios.post(`${process.env.VUE_APP_ENV_API_URL}PortalMarkRecord/CreateMarkRecordMidTerm`, payload, { headers })
                    .then(resp => resp.data)
                    .then(returnData => {
                        resolve(returnData)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        GetStudentForMarkRecord({ rootState }, { SectionId,SubjectId, RegisteredTermId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalMarkRecord/GetStudentForMarkRecord?SectionId=${SectionId}&SubjectId=${SubjectId}&RegisteredTermId=${RegisteredTermId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetStudentForMarkRecordMidTerm({ rootState }, { SectionId,SubjectId, RegisteredTermId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalMarkRecord/GetStudentForMarkRecordMidTerm?SectionId=${SectionId}&SubjectId=${SubjectId}&RegisteredTermId=${RegisteredTermId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },      

    }
}

export default PortalMarkRecord